// 任务管理
export default {
    unpublished: 'Unpublished',
    published: 'Published',
    inExecution: 'In Execution',
    completed: 'Completed',
    deleted: 'Deleted',
    taskTotal: 'Total number of tasks',
    newTask: 'New Task',
    approvalStatus: 'Approval Status',
    all: 'All',
    pending: 'Pending',
    timeoutNotApproved: 'Timeout not approved',
    didNotPass: 'Did not pass',
    approved: 'Approved',
    generateReport: 'Generate Report',
    approver: 'Approver',
    reason: 'Reason',
    taskNature: 'Task Nature',
    aging: 'Aging',
    efficient: 'Efficient',
    invalid: 'Invalid',
    onTime: 'On Time',
    timeOut: 'Time Out',
    taskStatus: 'Task Status',
    model: 'UAV Model',
    mount: 'Mount',
    submit: 'Submit',
    release: 'Release',
    revoke: 'Revoke',
    check: 'Check',
    achievementDisplay: 'Achievement Display',
    recover: 'Recover',
    postTask: 'Post Task',
    missionReport: 'Mission Report',
    tip_submit: 'Are you sure you want to submit?',
    drawingScale: 'Drawing Scale',
    area: 'Area',
    mu: 'mu',
    perimeter: 'Perimeter',
    have: 'have',
    without: 'without',
    workLocation: 'Work Location',
    tip_selectDev: 'Please select device type',
    tip_selectMount: 'Please select mount type',
    tip_enterDeadline: 'Please enter a deadline',
    other: 'Other',
    tip_leastOne: 'Please plan at least one spot',
    tip_leastThree: 'Please plan at least three points',
    siteName: 'Site Name',
    selectNumber: 'Number of selected points',
    tip_enterSiteName: 'Please enter a site name',
    public: 'Public',
    personal: 'Personal',
    personalAndShared: 'Personal and Shared',
    customize: 'Customize',
    userName: 'User Name',
    tip_userName: 'Please enter user name',
    tip_phoneNumber: 'Please enter the phone number',
    phoneNumber: 'Phone Number',
    department: 'Department',
    licenseType: 'License Type',
    systemNotification: 'System Notification',
    viewTasks: 'View Tasks',
    executor: 'Executor',
    uavNumber: 'UAV Number',
    flightTime: 'Flight Time',
    founder: 'Founder',
    finisher: 'Finisher',
    role: 'Role',
    exportReport: 'Export Report',
    cumulativeTime: 'Cumulative Time',
    taskName: 'Task Name',
    startingPoint: 'starting Point',
    alreadyHave: 'Already Have',
    new: 'New',
    mapPickup: 'Map Pickup',
    endPoint: 'End Point',
    automaticApproval: 'Automatic Approval',
}